import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Warning } from "@phosphor-icons/react";

const KEY = "dl_age_confirmed_v1";

export const AgeBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const confirmed = localStorage.getItem(KEY);
    if (!confirmed) {
      const t = setTimeout(() => setVisible(true), 600);
      return () => clearTimeout(t);
    }
  }, []);

  const confirm = () => {
    localStorage.setItem(KEY, "true");
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5 }}
            className="fixed inset-0 z-40 bg-ink/40 backdrop-blur-[3px]"
            aria-hidden="true"
          />
          <motion.div
            data-testid="age-confirmation-banner"
            role="dialog"
            aria-label="Age confirmation"
            initial={{ y: "110%" }}
            animate={{ y: "0%" }}
            exit={{ y: "110%" }}
            transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
            className="fixed bottom-0 left-0 w-full z-50 bg-ink text-paper border-t-4 border-oxblood"
          >
            <div className="mx-auto max-w-[1400px] px-6 md:px-12 py-6 flex flex-col lg:flex-row lg:items-center gap-6">
              <div className="flex items-start gap-4 flex-1">
                <Warning size={30} weight="light" className="shrink-0 text-oxblood mt-1" />
                <div>
                  <p className="text-xs uppercase tracking-[0.2em] font-bold text-oxblood mb-1">
                    Adults only — 18+
                  </p>
                  <p className="text-sm text-paper/80 leading-relaxed max-w-3xl">
                    This platform is strictly for adults aged 18 and over. We
                    prohibit illegal content, paid sexual services, harassment,
                    and any use by minors. By entering, you confirm you are of
                    legal age and agree to our{" "}
                    <a href="/terms" className="underline hover:text-paper">Terms of Use</a> and{" "}
                    <a href="/community-rules" className="underline hover:text-paper">Community Rules</a>.
                  </p>
                </div>
              </div>
              <div className="flex items-center gap-4 shrink-0">
                <a
                  href="https://www.google.com"
                  data-testid="age-exit-button"
                  className="text-sm text-paper/50 hover:text-paper transition-colors"
                >
                  Leave
                </a>
                <button
                  data-testid="age-confirm-button"
                  onClick={confirm}
                  className="group relative overflow-hidden bg-paper text-ink px-8 py-4 text-sm font-semibold uppercase tracking-wider"
                >
                  <span className="relative z-10 transition-colors duration-500 group-hover:text-paper">
                    I am 18 or older
                  </span>
                  <span className="absolute inset-0 bg-oxblood translate-y-full group-hover:translate-y-0 transition-transform duration-500 ease-[cubic-bezier(0.16,1,0.3,1)]" />
                </button>
              </div>
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
};
